import { useTranslation } from 'react-i18next'
import { CarouselBase, Div, Text } from 'ui/index'
import useResponsive from 'utils/hooks/useResponsive'

import Card from './Card'

import DashboardImg_es from 'assets/images/beCreator/dashboard_es.png'
import DashboardRespImg_es from 'assets/images/beCreator/dashboardResponsive_es.png'
import DashboardImg_en from 'assets/images/beCreator/dashboard_en.png'
import DashboardRespImg_en from 'assets/images/beCreator/dashboardResponsive_en.png'

import CardsImg_es from 'assets/images/beCreator/cards_es.png'
import CardsRespImg_es from 'assets/images/beCreator/cardsResponsive_es.png'
import CardsImg_en from 'assets/images/beCreator/cards_en.png'
import CardsRespImg_en from 'assets/images/beCreator/cardsResponsive_en.png'
import i18n from 'i18n'


const Earn = () => {
  
  const { t } = useTranslation()
  const { isMobile, isTab } = useResponsive()

  const currentCards = i18n.language === 'es' ? CardsImg_es : CardsImg_en
  const currentCardsResp = i18n.language === 'es' ? CardsRespImg_es : CardsRespImg_en
  const currentDashboard = i18n.language === 'es' ? DashboardImg_es : DashboardImg_en
  const currentDashboardResp = i18n.language === 'es' ? DashboardRespImg_es : DashboardRespImg_en


  return (
    <Div marginTop={isMobile ? 64 : 120}>

      <Div width='90%' maxWidth={670} margin='0 auto'>
        <Text size={isMobile ? '2xl' : '4xl'} color='headline' align='center'>
          {t('earnFlixxWithContentAccess')}
        </Text>
      </Div>

      <Div width='90%' maxWidth={570} margin='24px auto 64px'>
        <Text size={isMobile ? 'sm' : 'base'} align='center'>
          {t('receiveFlixxInYourAccount')}
        </Text>
      </Div>

      <Div maxWidth={1160} margin='0 auto'>
        <CarouselBase offsetRight={35} slidesPerView={isMobile ? 1 : 2}>
          <Card
            title={t('yourContent')}
            description={t('followUpInteractions')}
            alt=''
            src={isTab ? currentDashboardResp : currentDashboard}
          />

          <Card
            title={t('yourEarnings')}
            description={t('reviewAndFilterEarnings')}
            alt=''
            src={isTab ? currentCardsResp : currentCards}
          />
        </CarouselBase>
      </Div>

    </Div>
  )
}

export default Earn